//Background Image
import { planimetriaUrlParamsForBackground } from "../functions/UrlParams";

const urlBase = process.env.REACT_APP_URL;

export default function useBackGroundPlanimetria(params) {
  const {id, action } = planimetriaUrlParamsForBackground(params);
  return urlBase + action + id ;
}